import { Component, OnInit, Renderer, ViewChild } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AccessControlService } from 'src/app/services/access-control.service';
import { environment } from 'src/environments/environment';
import { ClipboardService } from 'ngx-clipboard';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-application-listing',
  templateUrl: './application-listing.component.html',
  styleUrls: ['./application-listing.component.css']
})
export class ApplicationListingComponent implements OnInit {
  serverUrl: String = environment.serverUrl;
  model: any = {};
  systemmoduleList: any = [];
  is_copied = false;
  org_id: string;
  username: string;
  displayedColumns: string[] = ['application_name', '_id', 'application_description', 'created_by', 'Actions'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  noData: any;
  isLoading: boolean;
  constructor(private authService: AuthService,
    private alertService: AlertService,
    private accesscontrolService: AccessControlService,
    private renderer: Renderer,
    private router: Router,
    private _clipboardService: ClipboardService) { }

  ngOnInit() {
    this.accesscontrolService.getRoute.next(true);
    this.org_id = localStorage.getItem('org_id');
    this.username = localStorage.getItem('username');
    this.getapps();
  }

  copyToClipboard(action) {
    this.is_copied = this._clipboardService.copyFromContent(action);
    setTimeout(() => {
      this.is_copied = false;
    }, 700);

  }
  addApplication() {
    this.accesscontrolService.addsystemModule(this.model).subscribe((res) => {
    }, error => {

    }, () => {
      this.alertService.updateAlert('Application Added Successfully');
      this.router.navigate(['/system-module-listing']);
    });
  }
  delete(id: any) {
    Swal({
      title: 'Are you sure you want delete?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Deleted!',
          'Application has been deleted.',
          'success'
        ).then(() => {
          // this should execute now
          this.accesscontrolService.deleteApplication(id).subscribe((res) => {
            this.getapps();
          }, error => { },
            () => {
            });
        });
      }

    });
  }
  addRoute() {
    this.router.navigate(['add-application'], { queryParams: { opt: 'add' } });
  }
  closeAlert() {
    this.is_copied = false;
  }
  getapps() {
    this.isLoading = true;
    this.accesscontrolService.getOrganizationApplications(this.org_id).subscribe(
      (res: any) => {
        this.dataSource = new MatTableDataSource<any>(res.rows);
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
        this.isLoading = false;
      },
      (err) => {this.isLoading = false; }
    );
  }
  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
